export enum EmptyLabels {
  NotSpecified = 'Not Specified'
}

export enum EmptyLabelSizes {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
